module.exports = __webpack_public_path__ + "img/music-work-icon17.bf31c1eb.png";